import { FILTER_QUERY_ACTIONS_TYPES } from "../consts";
import { GenericActions, GenericFilters } from "../types";

export function persistReducerFunction<
  State extends GenericFilters,
  Action extends GenericActions,
>(state: State, action: Action): State {
  if (action.type === FILTER_QUERY_ACTIONS_TYPES.CLEAR) {
    return { tab: state.tab } as State;
  }
  if (action.type === FILTER_QUERY_ACTIONS_TYPES.SET_STATE) {
    return action.value as State;
  }
  if (
    action.type === FILTER_QUERY_ACTIONS_TYPES.RESET ||
    action.type === FILTER_QUERY_ACTIONS_TYPES.RESET_TO_INITIAL
  ) {
    return state;
  }
  return { ...state, [action.type]: action?.value } as State;
}
